import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'

const OpenQuestion = (props) => {
	//objects
	const { checklistResponse, question } = props
	//Functions,
	const { onChecklistResponse } = props
	//bool props
	const { canBeAddedResponse, isSaving } = props
	let existSupplierAnswer = checklistResponse && checklistResponse.QuestionResponses.find((x) => x.Question.Token === question.Token)
	return (
		<TextField
			label='Respuesta'
			fullWidth
			margin='dense'
			variant='outlined'
			// className={classNames(classes.textField, classes.dense)}
			onBlur={(event) => onChecklistResponse(question.Token, event.target.value)}
			disabled={!canBeAddedResponse || isSaving}
			defaultValue={existSupplierAnswer ? existSupplierAnswer.OpenAnswer : ''}
			multiline
		/>
	)
}

OpenQuestion.propTypes = {
	serie: PropTypes.shape({
		Serie: PropTypes.string,
		Model: PropTypes.string
	}),
	onSave: PropTypes.func.isRequired
}

export default OpenQuestion
